import React from 'react';
import DDF from './Old';
import PostDdf from './ManageGroups';
import { FeatureToggle } from '../../components/FeatureToggle';

export default function ManageGroupsUnderToggle() {
  // eslint-disable-next-line react/jsx-pascal-case
  return <FeatureToggle featureName="postDDF" active={() => <PostDdf />} inactive={() => <DDF />} />;
}
